// The built-in browsers inside Instagram, Facebook, TikTok, Snapchat and
// LinkedIn. Google refuses to sign anyone in from them, and a sign-in started
// there can't be finished in Safari (lib/auth/pkce.ts), so Google sign-in
// asks people to open the page in their real browser first. Our own iOS
// shell is not one of these: its user agent carries "BOOTHApp" instead.

const IN_APP_UA = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|BytedanceWebview|musical_ly|TikTok|Snapchat|LinkedInApp/i

export function isInAppBrowser(userAgent?: string | null): boolean {
  const ua = userAgent ?? (typeof navigator === "undefined" ? "" : navigator.userAgent)
  return IN_APP_UA.test(ua)
}

export const IN_APP_GOOGLE_MESSAGE =
  "Google sign-in doesn't work inside this app's browser. Tap ••• and choose Open in browser, or sign in with your email."
